<template>
  <div class="page-container">
    <!-- 채팅 히스토리 사이드바 -->
    <div class="history-sidebar">
      <div class="history-title">
        <span class="history-icon">📚</span>
        <span class="history-text">Chat History</span>
      </div>
      <div class="history-list">
        <div
            v-for="thread in chatThreads"
            :key="thread.id"
            :class="['history-item', { 'active': thread.id === threadId }]"
            @click="loadChatThread(thread.id)" >
          <div class="thread-preview">{{ thread.preview }}</div>
        </div>
      </div>
    </div>

    <div class="chat-container">
      <div class="chat-box" ref="chatBox">
        <div v-for="(message, index) in messages" :key="index" class="message" :class="{'user': message.sender === 'user', 'bot': message.sender === 'bot'}">
          <div v-if="message.sender === 'bot'" class="bot-avatar">🔎</div>
          <!-- 텍스트 메시지 렌더링 -->
          <div v-if="message.type === 'text'" class="message-content" v-html="message.text"></div>
          <!-- 동적 컴포넌트 렌더링 -->
          <div v-else-if="message.type === 'component'" class="message-content">
            <component :is="message.component" v-bind="message.props"></component>
          </div>
        </div>
      </div>
      <div class="input-container rounded-container">
        <input v-model="newMessage" @keyup.enter="sendMessage" placeholder="메시지를 입력하세요..." class="message-input" />
        <button @click="sendMessage" class="send-button">전송</button>
      </div>
    </div>
  </div>
</template>

<script>
import {ref, onUpdated, nextTick, markRaw, onMounted} from 'vue';
import axios from 'axios';
import { marked } from 'marked';
import conf from "@/assets/js/conf";
import ChatBotMsgComp from "@/views/componentType/ChatBotMsgComp.vue";
import Cookies from "js-cookie";

export default {
  components: {ChatBotMsgComp},
  setup() {
    let threadId = ref(Date.now().toString(36));
    // let threadId = Date.now().toString(36);
    // decoding : parseInt(threadId, 36);

    const messages = ref([
      { sender: 'bot', text: '안녕하세요! 무엇이 궁금하세요?', type: 'text'}
    ]);
    const chatThreads = ref([]);
    const newMessage = ref('');
    const chatBox = ref(null);

    // Chat History 중 Title 을 클릭 했을때, 기존 Chat History 를 불러 오는 부분
    const loadChatThread = async (selectedThreadId) => {
      console.log("selectedThreadId: " + selectedThreadId);
      threadId.value = selectedThreadId;

      // Clear existing messages
      messages.value = [];

      // Add loading message
      messages.value.push({sender: 'bot', text: '대화 내용을 불러오는 중...', type: 'text'});

      // Add delay of 1.5 seconds
      await new Promise(resolve => setTimeout(resolve, 1500));

      // Front's Thread Id = Server's Session Id
      const session_id = selectedThreadId;

      const baseURL = conf.getAIDTBaseURL();
      const url = baseURL + '/chat/get_session_messages/' + session_id;

      try {
        const response = await axios.get(url);

        // Remove loading message
        messages.value = [];

        response.data.messages.forEach(message => {
          let md_text = message.content;
          messages.value.push({
            sender: message.role === 'user' ? 'user' : 'bot',
            component: markRaw(ChatBotMsgComp),
            props: {ans_content: md_text}, // md_text를 ans_content로 전달
            type: 'component'
          });
        });
      } catch (error) {
        messages.value = [{
          sender: 'bot',
          text: '대화 내용을 불러오는데 실패했습니다.',
          type: 'text'
        }];
      }
    };

    const getUserFromCookie = () => {
      const userStr = Cookies.get('user');
      return userStr ? JSON.parse(userStr) : null;
    }

    const loadUserChatTitleHistory = async () => {
      // 로그인시 vuex store 와 cookie 에 사용자 정보를 저장하는데
      // vuex store 에서 불러오는 방법 잘 안되므로, 여기서는 cookie 에서 받아 오도록 처리
      const user_name = getUserFromCookie().sub;

      const baseURL = conf.getAIDTBaseURL();
      const url = baseURL + '/chat/get_user_sessions/' + user_name

      const response = await axios.get(url);
      response.data.messages?.forEach(message => {
        chatThreads.value.push({
          id: message.id,
          // 서버에서는 50자리 처리를 하였으나, Front 에서는 UI 상 20 자리까지 표현
          preview: message.title.substring(0, 20) + (message.title.length > 20 ? '...' : ''),
          timestamp: message.updated_at
        });
      });
    }

    const sendMessage = async () => {
      // cookie 에서 사용자 정보 받아옴
      const user_name = getUserFromCookie().sub;

      if (newMessage.value.trim() === '') return;

      // 새 메시지를 채팅 스레드에 추가
      const newThread = {
        id: threadId.value,
        preview: newMessage.value.substring(0, 20) + (newMessage.value.length > 20 ? '...' : ''),
        timestamp: Date.now()
      };

      if (!chatThreads.value.find(thread => thread.id === threadId.value)) {
        chatThreads.value.unshift(newThread);
      }

      messages.value.push({ sender: 'user', text: newMessage.value, type: 'text' });
      const userMessage = newMessage.value;
      newMessage.value = '';

      let loadingText = "응답을 기다리는 중 ...";
      const loadingMessage = { sender: 'bot', text: `${loadingText}`, type: 'text' };
      messages.value.push(loadingMessage);

      const baseURL = conf.getAIDTBaseURL();
      const url = baseURL + '/chat'
      const headerParams = {
        "Content-Type": "application/json"
      }

      try {
        const payload = {
          thread_id: threadId.value,
          user_id: user_name,
          message: userMessage,
          role: "user"
        }
        const response = await axios.post(url,  payload, { headers: headerParams });

        const ans_content = response.data.message.content;

        messages.value.pop(); // 로딩 메시지 제거
        messages.value.push({
          sender: 'bot',
          component: markRaw(ChatBotMsgComp),
          props: { ans_content }, // items를 props로 전달
          type: 'component'
        });

      } catch (error) {
        messages.value.pop(); // 로딩 메시지 제거
        messages.value.push({ sender: 'bot', text: marked('**오류가 발생했습니다.** 다시 시도해주세요.')});
      }
    };

    onUpdated(() => {
      nextTick(() => {
        if (chatBox.value) {
          chatBox.value.scrollTo({ top: chatBox.value.scrollHeight, behavior: 'smooth' });
        }
      });
    });

    onMounted(async () => {
      try {
        await loadUserChatTitleHistory();
      } catch (error) {
        console.log(error);
      }
    });
    return {
      messages,
      newMessage,
      sendMessage,
      chatBox,
      threadId,
      chatThreads,
      loadChatThread,
      loadUserChatTitleHistory,
      getUserFromCookie
    };
  },
};
</script>

<style scoped>
::v-deep(*)
{
  all: revert;
}

html, body {
  margin: 0;
  padding: 0;
  height: 100%;
  background-color: #f0f0f0;
  font-family: Arial, sans-serif;
}

.page-container {
  display: flex;
  gap: 10px;
  padding: 10px;
  height: 66vh;
}

.history-sidebar {
  width: 250px;
  background: #ffffff;
  border-radius: 10px;
  border: 1px solid #ddd;
  display: flex;
  flex-direction: column;
}

.history-title {
  padding: 15px;
  font-size: 16px;
  font-weight: bold;
  border-bottom: 1px solid #ddd;
  background-color: #f8f9fa;
  border-radius: 10px 10px 0 0;
  display: flex;
  align-items: flex-end; /* bottom 정렬을 위해 변경 */
  gap: 8px;
}

.history-icon {
  font-size: 18px;
  line-height: 1;
  display: flex;
  align-items: flex-end;
}

.history-text {
  line-height: 1;
}

.history-list {
  flex: 1;
  overflow-y: auto;
  padding: 10px;
}

.history-item {
  padding: 12px;
  margin-bottom: 8px;
  background: #f8f9fa;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  border: 1px solid transparent;
}

.history-item:hover {
  background-color: #e9ecef;
}

.history-item.active {
  background-color: #e3f2fd;
  border-color: #007bff;
}

.thread-preview {
  font-size: 14px;
  color: #333;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.chat-container {
  width: 938px;
  display: flex;
  flex-direction: column;
  height: 66vh;
  justify-content: space-between;
  padding: 1px;
}

.chat-box {
  flex: 1;
  overflow-y: auto;
  padding: 15px;
  background: #ffffff;
  border-radius: 10px;
  border: 1px solid #ddd;
}

.message {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  max-width: 100%;
}

.message.bot {
  justify-content: flex-start;
}

.message.user {
  justify-content: flex-end;
  align-self: flex-end;
  text-align: right;
}

.bot-avatar {
  width: 30px;
  height: 30px;
  background-color: #ddd;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: black;
  margin-right: 10px;
}

.message-content {
  padding: 10px 15px;
  border-radius: 20px;
  background: #e0e0e0;
  color: black;
  max-width: 100%;
  font-size: 14px;
}

.message.user .message-content {
  background: #007bff;
  color: white;
  text-align: left;
}

.input-container {
  display: flex;
  padding: 10px;
  background: #ffffff;
  border-top: 1px solid #ddd;
}

.input-container.rounded-container {
  border-radius: 10px;
  margin: 2px;
  padding: 15px;
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.1);
}

.message-input {
  flex: 1;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 20px;
  outline: none;
  background: white;
  color: black;
}

.send-button {
  margin-left: 10px;
  padding: 10px 15px;
  border: none;
  border-radius: 20px;
  background: #007bff;
  color: white;
  cursor: pointer;
  transition: background 0.3s;
}

</style>